import styled from 'libs/styled';
import { useTranslation } from 'react-i18next';
import useAppSelector from '@sportson/core-web/hooks/useAppSelector';
import useAppDispatch from '@sportson/core-web/hooks/useAppDispatch';
import useBreakpoint from '@sportson/core-web/hooks/useBreakpoint';
import { show as showOverlay } from '@sportson/core-web/state/application/overlay';
import { getAvailablePartialPaymentOptions } from '@sportson/core-web/utils/getAvailablePartialPaymentOptions';
import CoreButton from '@grebban/react-core-components/Button';

import Text from 'components/Text';
import { ResursBankLogo } from 'assets/media/icons/ResursBankLogo';

const WrapperButton = styled(CoreButton)`
    display: flex;
    gap: 16px;
    width: 100%;
    justify-content: space-between;
    border-radius: 4px;

    background-color: var(--color-neutrals-100);
`;

const LogoWrapper = styled('div')`
    display: flex;
    align-items: center;

    height: 100%;
    width: fit-content;
`;

const StyledText = styled(Text)`
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
`;

export const PartialPayment = ({ price, overlayTextContent }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const isMobile = useBreakpoint({ to: 'tablet.sm' });

    const handleOnClick = () => {
        dispatch(
            showOverlay({
                view: 'partialPaymentOverlay',
                transition: isMobile ? 'from-left' : 'from-right',
                data: { price, overlayTextContent },
            }),
        );
    };

    const { monthlyOptions, downPayment } = getAvailablePartialPaymentOptions(price);

    if (monthlyOptions.length === 0) {
        return null;
    }

    return (
        <WrapperButton onClick={handleOnClick} p={['12px 16px', null, null, '12px 24px']}>
            <LogoWrapper>
                <ResursBankLogo />
            </LogoWrapper>
            <StyledText typography="UI/12_100_0_450">
                {t('partial_payment.button_text')}
                {downPayment && (
                    <Text as="span" typography="UI/12_100_0_450" marginLeft="4px">
                        {t('partial_payment.down_payment')} {t('price.with_currency', { price: downPayment })}.
                    </Text>
                )}
            </StyledText>
            <Text
                typography="UI/12_100_0_450"
                color="var(--color-neutrals-500)"
                width="fit-content"
                minWidth="fit-content"
            >
                {t('read_more')}
            </Text>
        </WrapperButton>
    );
};
